import { ILeaf, INode } from 'shared/types/tree'
import {
  convertStringToRegex,
  keyTest,
  objectTest,
  isLeaf,
  isNode,
} from 'shared/utils'
import { NodeType } from 'shared/types/ingestion'
import { contentKeys, withoutContent } from 'shared/utils/contentTransforms'

export function convertUserInputToFilterValues(input: string) {
  return input
    .split(',')
    .map((s) => s.trim())
    .map((v) => {
      if (!isNaN(Number(v))) return Number(v)
      if (v === 'true') return true
      if (v === 'false') return false
      const asString = String(v)
      return convertStringToRegex(asString) ?? asString
    })
}

export function allContentForFilterTest(item: INode | ILeaf) {
  if (isNode(item)) {
    return allNodeContent(item)
  } else if (isLeaf(item)) {
    return allLeafContent(item)
  }
  return ''
}

function allNodeContent(node: INode) {
  if (withoutContent.includes(node.type as NodeType)) return node.title ?? ''
  return contentKeys
    .reduce<string[]>((acc, key) => {
      const keys = key.split('.')
      const keyVal = keys.reduce<unknown>((currentKeyVal, currKey) => {
        if (objectTest(currentKeyVal) && keyTest(currentKeyVal, currKey)) {
          return currentKeyVal[currKey]
        }
        return currentKeyVal
      }, node)
      if (typeof keyVal === 'string') return [...acc, keyVal]
      return acc
    }, [])
    .join(' ')
}

function allLeafContent(leaf: ILeaf) {
  // Not really sure how to pull out the leaf content for this, just test all
  return JSON.stringify(leaf)
}
